import { render } from "./ConsentDetail.vue?vue&type=template&id=7ca6846a&scoped=true"
import script from "./ConsentDetail.vue?vue&type=script&lang=js"
export * from "./ConsentDetail.vue?vue&type=script&lang=js"

import "./ConsentDetail.vue?vue&type=style&index=0&id=7ca6846a&scoped=true&lang=css"

import exportComponent from "/var/www/html/star-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca6846a"]])

export default __exports__